export enum QuoteStatusEnum {
  CHANGE_REQUESTED = 'CHANGE_REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  APPROVAL_REQUESTED = 'APPROVAL_REQUESTED',
  APPROVED = 'APPROVED',
  SALES_ORDER = "SALES_ORDER"
}
